<div
  class="!w-full d-flex flex-col justify-center align-items-center border-box"
  style="padding: 24px 12px"
>
  <img style="width: 160px" [src]="image" />
  <div class="!mt-8 max-wx-100 d-flex flex-col gap-y-2 text-center align-items-center">
    <p class="orgbrain-larger-gray-text max-wx-70" style="font-size: 18px">
      {{ text }}
    </p>
    <p *ngIf="subtext" class="orgbrain-gray-text">
      {{ subtext }}
    </p>
    <ng-content></ng-content>
  </div>
</div>
